import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { RaffleLot } from './raffle-lot'
import { raffleLotActions } from './raffle-lot.actions'
import * as fromRaffleLot from './raffle-lot.reducer'
import { RaffleLotService } from './raffle-lot.service'
import { concatMap, map } from 'rxjs/operators'

@Injectable()
export class RaffleLotEffects extends ResourceEffects<RaffleLot> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public raffleLotService: RaffleLotService
  ) {
    super(
      fromRaffleLot.FEATURE_NAME,
      raffleLotService,
      raffleLotActions,
      actions$
    )
  }

  createOne = createEffect(() =>
    this.actions$.pipe(
      ofType(raffleLotActions.createOne),
      concatMap((action) => {
        return this.raffleLotService.createOne(action.entity).pipe(
          map((raffleLot) => {
            return raffleLotActions.upsertOne({
              entity: {
                ...raffleLot
              }
            })
          })
        )
      })
    )
  )

  deleteOne = createEffect(() =>
    this.actions$.pipe(
      ofType(raffleLotActions.deleteOne),
      concatMap((action) => {
        const raffleLotId = action.id
        return this.raffleLotService
          .deleteOne(action.id)
          .pipe(
            map((response) => raffleLotActions.removeOne({ id: raffleLotId }))
          )
      })
    )
  )
}
